import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pagination, Box, Typography } from '@mui/material';
import { StyledCustomPagination } from './index.style';

const CustomPagination = ({
  currentPage,
  limit,
  total,
  onChangePagination,
}) => {
  const { t } = useTranslation();
  const totalPages = Math.ceil(total / limit);

  return (
    <StyledCustomPagination>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        mt={2}
      >
        <Typography variant="body1">
          {t('paginationText', {
            total,
          })}
        </Typography>
        <Pagination
          color="primary"
          className="pagination"
          page={currentPage}
          count={totalPages}
          onChange={(e, page) => onChangePagination(page)}
        />
      </Box>
    </StyledCustomPagination>
  );
};

export default CustomPagination;
